/* STEP 10 (owner "STEP 10 — LIVE SAFETY + MARS REHEARSAL" Card V1, 30-Oct-2026 23:25 KSA) — EN + AR of the texts lane C adds:
   s10.errors  the Founder Errors tab: notice groups ("Info") — a fallback forced by the Founder test switch, a screen file of an old
               build that one reload recovered — are kept but not pending (C2 #10, #2 / #3 / #11). No provider names. */
export const I18N_S10 = {
  en: {
    s10: {
      errors: {
        info: "Info",
        infoCount: "Info {n}",
        infoTitle: "Notices, not errors: a screen fallback forced by the Founder test switch, or a screen file of an old build that one reload recovered. Kept for the record; not counted as pending.",
      },
    },
  },
  ar: {
    s10: {
      errors: {
        info: "إشعار",
        infoCount: "إشعارات {n}",
        infoTitle: "إشعارات وليست أخطاء: نسخة محفوظة عُرضت لأن مفتاح الاختبار في بوابة المؤسس فرضها، أو ملف شاشة من إصدار قديم أصلحته إعادة تحميل واحدة. تُحفظ للسجل ولا تُحسب ضمن المعلّقة.",
      },
    },
  },
};

export default I18N_S10;
